module.exports = __webpack_public_path__ + "static/img/qingfeng_zhibofengmian.50ceeba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingfeng_zhibofengmian.jpg
// module id = iAZE
// module chunks = 1